<div class="wrapper" *ngIf="buildingDetails">
  <div class="nom_de_immeuble">
    {{ buildingDetails.nom_immeuble || 'Fiche immeuble' }}
  </div>
  <div class="address">
    <img
      src="assets/images/coordonnees_comment_icones_punaise.svg"
      alt=""
      class="icon"
    />
    <p>{{ formatTitle() }}</p>
  </div>

  <div class="coordinates">
    <div class="element">
      <div class="title">
        {{ buildingDetails.direction_immobiliere_nom }}
      </div>
      <div class="element-lines-wrapper">
        <div class="element-line">
          <img
            src="assets/images/coordonnees_comment_icones_personnage.svg"
            alt=""
            class="element-icon"
          />
          Directrice ou directeur immobilier :
          {{ formatDirectorName(buildingDetails.nom_directeur_immobilier) }}
        </div>
        <div class="element-line">
          <img
            src="assets/images/coordonnees_comment_icones_punaise.svg"
            alt=""
            class="element-icon"
          />
          {{
            formatAdminAddress(buildingDetails.adresse_direction_immobiliere)
          }}
        </div>
        <div class="element-line">
          <img
            src="assets/images/coordonnees_comment_icones_telephone.svg"
            alt=""
            class="element-icon"
          />
          {{ formatPhoneNumber(buildingDetails.tel_direction_immobiliere) }}
        </div>
        <div class="element-line">
          <img
            src="assets/images/coordonnees_comment_icones_enveloppe.svg"
            alt=""
            class="element-icon"
          />
          <a
            [href]="'mailto:' + buildingDetails.courriel_direction_immobiliere"
            >{{
              buildingDetails.courriel_direction_immobiliere?.toLowerCase()
            }}</a
          >
        </div>
      </div>
    </div>

    <div class="element" *ngFor="let cai of buildingDetails.cais">
      <div class="title">
        Coordonnatrice ou coordonnateur à l'administration immobilière (CAI)
      </div>
      <div class="element-lines-wrapper">
        <div class="element-line">
          <img
            src="assets/images/coordonnees_comment_icones_personnage.svg"
            alt=""
            class="element-icon"
          />
          {{ cai.cai_prenom }} {{ cai.cai_nom }}
        </div>
        <div class="element-line">
          <img
            src="assets/images/coordonnees_comment_icones_enveloppe.svg"
            alt=""
            class="element-icon"
          />
          <a [href]="'mailto:' + cai.cai_courriel">{{
            cai.cai_courriel?.toLowerCase()
          }}</a>
        </div>
      </div>
    </div>
  </div>

  <div class="coordinates-caract">
    <div class="title">Caractéristiques</div>

    <div class="element-line-2">
      Numéro de l'immeuble :
      <strong
        >{{ buildingDetails.numero_immeuble }}-{{
          buildingDetails.type_propriete_ou_location
        }}</strong
      >
    </div>
    <div class="element-line-2">
      Vocation principale :
      <strong>{{ buildingDetails.vocation_principale }}</strong>
    </div>
    <div class="element-line-2">
      Type :
      <strong>{{
        resolveTypeValue(buildingDetails.type_propriete_ou_location)
      }}</strong>
    </div>
    <div class="element-line-2">
      Immeuble patrimonial :
      <strong>{{
        buildingDetails.immeuble_patrimonial === 'OUI' ? 'Oui' : 'Non'
      }}</strong>
    </div>
    <div class="element-line-2">
      Superficie locative :
      <strong>{{ buildingDetails.superficie_locative }} m²</strong>
    </div>
    <div class="element-line-2">
      Certification(s) : <strong>{{ formatCertifications() }}</strong>
    </div>
  </div>

  <div class="element-lines-wrapper">
    <div class="element-line">
      <button class="link-button" (click)="navigateToPoint()">
        Voir sur la carte de l'outil de repérage
      </button>
    </div>
    <div class="element-line">
      <button class="link-button" (click)="openGoogleMaps()">
        Voir sur Google Maps
      </button>
    </div>
  </div>
</div>
